<div class="media" [ngSwitch]="isLocalised">
    <fui-icon [height]="height" [icon]="'globe'" *ngSwitchDefault [width]="width"></fui-icon>
    <fui-icon [height]="height" [icon]="'globe-marker'" *ngSwitchCase="true" [width]="width"></fui-icon>
</div>
